var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3325 11.7288C38.0949 11.4505 37.7781 11.2915 37.4217 11.2915H35.4021V2.14687C35.4021 1.51073 34.8873 0.954102 34.2141 0.954102H5.38526C4.75166 0.954102 4.19726 1.47097 4.19726 2.14687V7.27579H2.17766C1.82126 7.27579 1.50446 7.43483 1.30646 7.67338C1.06886 7.95169 0.989655 8.26977 1.02926 8.6276L4.35566 30.6143C4.43486 31.171 4.94966 31.6083 5.50406 31.6083H34.0953C34.6497 31.6083 35.1249 31.2107 35.2437 30.6541L38.6097 12.7228C38.6493 12.3649 38.5701 12.0071 38.3325 11.7288ZM6.53366 3.33964H33.0657V11.3312H16.2357L14.9685 8.03121C14.8101 7.59386 14.3745 7.27579 13.8597 7.27579H6.53366V3.33964ZM33.1449 29.2625H6.49406L3.52406 9.62157H13.0677L14.3349 12.9216C14.4933 13.3589 14.9289 13.677 15.4437 13.677H36.0357L33.1449 29.2625Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0087 22.2256L17.7015 24.9292C17.9391 25.1678 18.2163 25.2871 18.5331 25.2871C18.8499 25.2871 19.1271 25.1678 19.3647 24.9292L24.5919 19.681C25.0671 19.2039 25.0671 18.4883 24.5919 18.0112C24.1167 17.534 23.4039 17.534 22.9287 18.0112L18.5331 22.4244L16.6719 20.5557C16.1967 20.0786 15.4839 20.0786 15.0087 20.5557C14.5335 21.0328 14.5335 21.7883 15.0087 22.2256Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.db28696d14e244936a0e64783777d980.svg";
export { ForwardRef as ReactComponent };